import pomu1 from '../../../media/experience/pomu/homepage.png';
import pomu2 from '../../../media/experience/pomu/submissions.jpeg';
import pomu3 from '../../../media/experience/pomu/teamPage.png';
import pomuVideo from '../../../media/experience/pomu/alpha_demo.mp4';
import thumbail from '../../../media/experience/pomu/video_thumbail.png';
import pomuPoster from '../../../media/experience/pomu/pomuIcon.jpeg';

const pomuData = {
  company: "Pomu-IO",
  slug: "pomu-io",
  poster: pomuPoster,
  location: "New York, NY",
  heroImage: thumbail,

  roles: [
    {
      title: "Software Engineer",
      start: "May 2024",
      end: "June 2025",
      summary: "At Pomu-IO, I led engineering for an AI-powered fashion platform that matches design submissions to manufacturers using multimodal image similarity—not keyword search. I owned the end-to-end recognition pipeline: image ingestion and preprocessing, Jina CLIP embedding generation, cosine-similarity ranking, and production APIs that served similarity results to the React client in real time. The core problem was pairing visually similar designs with the right manufacturing partners; embedding-space analysis (including bimodal cosine-similarity distributions) surfaced strong matches at high confidence while preserving a broader tail of viable alternatives. I integrated the CLIP model into a Django backend with PostgreSQL for metadata and embedding storage, built batch and on-demand inference paths for high-volume image workloads, and optimized query latency for interactive search. I also led the supporting full stack—React frontend with AWS Cognito auth, REST APIs, and AWS deployment (EC2, RDS, S3, Lambda)—so the ML pipeline shipped as a product, not a notebook.",
    },
  ],

  techStack: [
    "Jina CLIP",
    "Multimodal Embeddings",
    "Vector Similarity Search",
    "Cosine Similarity",
    "Computer Vision",
    "Image Preprocessing Pipelines",
    "PyTorch",
    "Django",
    "Python",
    "PostgreSQL",
    "React",
    "React Query",
    "AWS (EC2, RDS, S3, Lambda, Cognito)",
    "Docker",
    "REST APIs",
    "TypeScript",
    "Machine Learning"
  ],

  gallery: [
    { type: 'image', src: pomu1, alt: 'Pomu-IO platform homepage' },
    { type: 'image', src: pomu2, alt: 'Submissions interface' },
    { type: 'image', src: pomu3, alt: 'Team page' },
    { type: 'video', src: pomuVideo, alt: 'Platform demo video' },
  ],

  links: {
    company: "https://pomu.io",
    linkedin: "https://www.linkedin.com/company/pomu-io"
  }
};

export default pomuData;
